import { Injectable } from '@angular/core';
import {HttpParams} from "@angular/common/http";
import {grupo} from "../models/grupo";
import {HttpClientService} from "./http-client.service";

@Injectable({
  providedIn: 'root'
})
export class GrupoService {

  constructor(private http: HttpClientService) { }

  public getAll() {
    return this.http.get('/grupo/getall');
  }

  public getByIdProyecto(idProyecto: string) {
    let params = new HttpParams().set("idProyecto",idProyecto);
    return this.http.getWithParams('/grupo/getbyidproyecto', params);
  }

  getSizeConcentrador(idConcentrador: string) {
    let params = new HttpParams().set("idConcentrador",idConcentrador);
    return this.http.getWithParams('/grupo/getsizebyconcentrador', params);
  }

  public new(grupo: grupo) {
    return this.http.post('/grupo/new', grupo);
  }

  public addLumToGrupo(idGrupo: string, idConcentrador: string, idLuminaria: string, check: boolean) {

    let json =
      {
        "idGrupo": idGrupo,
        "idConcentrador": idConcentrador,
        "idLuminaria": idLuminaria,
        "check": check
      };

    return this.http.post('/grupo/addlumtogrupo', JSON.stringify(json));
  }

  public addSensorToGrupo(idGrupo: string, idConcentrador: string, idLuminaria: string, check: boolean) {

    let json =
      {
        "idGrupo": idGrupo,
        "idConcentrador": idConcentrador,
        "idLuminaria": idLuminaria,
        "check": check
      };

    return this.http.post('/grupo/addsensortogrupo', JSON.stringify(json));
  }

  public sendMasksGrupo(idLuminaria: string, idConcentrador: string) {

    let json =
      {
        "idLuminaria": idLuminaria,
        "idConcentrador": idConcentrador
      };

    return this.http.post('/grupo/sendmasksgrupo', JSON.stringify(json));
  }

  public delete(idGrupo: string, idConcentrador: string) {

    let json =
      {
        "idGrupo": idGrupo,
        "idConcentrador": idConcentrador,
      };

    return this.http.post('/grupo/delete', JSON.stringify(json));
  }

  public update(grupo: grupo) {
    return this.http.post('/grupo/update', grupo);
  }

}
